import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';
import ReportHelper from '../../report-helper';
import StatusHelper from '../../status-helper';
import ChartHelper from './chart-helper';
import { Container, Statistic, List } from 'semantic-ui-react';


class LOCChart extends Component
{
    getData( history, fetchType )
    {
        return _.map(
            history,
            ( report ) => {
                const reportHelper = new ReportHelper( report );

                const covBase = { loc : _.get( report, `data.plato.total.sloc`, null ) };

                covBase.name     = reportHelper.getReportName( fetchType );

                covBase.hash    = _.get( report, `data.pkg.hash` );
                covBase.tag     = _.get( report, `data.pkg.tag` );
                covBase.date    = _.get( report, `data.pkg.committed` );

                return covBase;
            }
        );
    }


    getTooltip( content )
    {
        if( ( !content.payload ) || ( content.payload.length <= 0 ) )
        {
            return null;
        }

        const data = content.payload[ 0 ].payload;

        return ( <Container text={true} className={`loc`}>

            <Statistic label={'LOC'} value={`${data.loc}`} />

            <List size={`small`} horizontal={true}>
                <List.Item header={`Hash`} description={ChartHelper.getHash( data.hash )} />
                <List.Item header={`Date`} description={moment( data.date ).format( 'YYYY-MM-DD hh:mm' )} />
                <List.Item header={`Tag`} description={data.tag || `n/a`} />
            </List>
        </Container> );
    }


    render()
    {
        const latest = _.get( this, 'props.pkg.latest' ),
            history = _.get( this, 'props.pkg.history' );

        if( !latest || !history )
        {
            return ( <div>Loading...</div> );
        }

        const colors = StatusHelper.getStatusColors( 'default' );

        return (
            <ResponsiveContainer width='100%' height='100%'>
                <LineChart
                           data={this.getData( history, this.props.fetchType )}
                           margin={{top: 8, right: 8, left: 8, bottom: 8}}>
                    <Tooltip content={this.getTooltip} />
                    <Line type="monotone" dataKey="loc" strokeWidth={2} stroke={colors.lineColors[ 0 ]} activeDot={{r: 8}}/>
                </LineChart>
            </ResponsiveContainer>
        );
    }
}

export default LOCChart;




// WEBPACK FOOTER //
// ./src/lib/components/Charts/LOCChart.js